import styled from 'styled-components';
import {
  Form,
} from 'antd';
import {
  COLOR_WHITE,
} from 'constants/colors';

export const FormContainer = styled(Form)`
  display: grid;
  padding: 2rem;
  grid-gap: 1.5rem;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(4, auto);
  background-color: ${COLOR_WHITE};
  border-radius: 3px;
  margin-top: 1.25rem;
`;

const BaseFormItem = styled(Form.Item)`
  margin: 0;

  & {
    >.ant-form-item-label>label {
      font-weight: pink;
    }
  }
`;

export const InputContainer = styled(BaseFormItem)`
  grid-column: 1 / 3;
`;

export const KeepSessionContainer = styled(BaseFormItem)`
  grid-column: 1 / 2;
  grid-row: 3 / 4;
`;

export const ButtonContainer = styled(BaseFormItem)`
  grid-column: 1 / 3;
`;
